module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ag-grid-vue', {
    staticClass: "ag-theme-material",
    staticStyle: {
      "width": "1010px",
      "height": "100%"
    },
    attrs: {
      "rowData": _vm.rowData,
      "columnDefs": _vm.columnDefs,
      "frameworkComponents": _vm.frameworkComponents,
      "context": _vm.context,
      "getContextMenuItems": _vm.getContextMenuItems
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e3c5a48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/permissions/components/UserList.vue
// module id = 1893
// module chunks = 0